import React from "react";

const SettingsSection = ({ title, icon, children }) => (
  <div className="space-y-5">
    <div className="flex items-center gap-2 mb-2">
      <div className="p-2 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-400 rounded-md">
        {icon}
      </div>
      <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
        {title}
      </h2>
    </div>
    <div className="border-t border-gray-100 dark:border-gray-700 pt-4">
      {children}
    </div>
  </div>
);

export default SettingsSection;
